import PosterTextProduct from './components/PosterTextProduct'
import PosterTextLoader from './components/PosterTextLoader'

export default {
    install(Vue, option) {
        Vue.component('PosterTextProductWebGL', PosterTextProduct);
        Vue.component('PosterTextLoader', PosterTextLoader);
    }
};